
import CommonButton from '~/components/common/button/CommonButton.vue'

export default {
  name: 'AvailableMassOrder',
  components: {
    CommonButton
  },
  layout: '',
  props: {
    usePossible: {
      type: Boolean,
      default: false,
    },
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    addrInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    page: { // 비로그인 상태에서 대량 주문 가능 지역 확인 후 로그인 페이지로 넘어온 경우 체크시 사용
      type: String,
      default: ''
    },
    loginYn: { // 로그인 여부
      type: Boolean,
      default: false
    },
  },
  data () {
    return {}
  },
  methods: {
    moveBy (type) {
      if (type === 'ins' && !this.loginYn) {
        this.$store.commit('ds/setBulkOrderDeliveryFormShow', this.addrInfo)
        // this.$emit('next', 2)
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
      } else if (type === 'ins' && this.loginYn) {
        this.$emit('next', 2)
      } else if (type === 'srch') {
        this.$emit('next', 0)
      }
    }
  }
}
